/**
 * Find Similar popup — Product information v1
 * Desktop: hover card → size/color picker → add to cart on size click
 * Mobile: bag icon uses raf-mobile-quick-add
 */
(function () {
  'use strict';

  var CSS_COLORS = {
    black: '#111111', white: '#ffffff', navy: '#1b2a4a', blue: '#2c4a7c',
    red: '#8b1e1e', olive: '#556b2f', tan: '#d2b48c', grey: '#8a8a8a', gray: '#8a8a8a'
  };

  function getModal(fs) {
    var modalId = fs.getAttribute('data-piv1-fs-modal-id');
    return modalId ? document.getElementById(modalId) : fs.querySelector('[data-piv1-fs-modal]');
  }

  function portalModal(fs, modal) {
    if (!modal || modal.dataset.piv1FsPortaled === '1') return;
    modal.dataset.piv1FsPortaled = '1';
    modal.dataset.piv1FsOwner = fs.id;
    document.body.appendChild(modal);
  }

  function cartAddUrl() {
    if (window.theme && theme.routes && theme.routes.cartAdd) return theme.routes.cartAdd;
    var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
    return root + (root.slice(-1) === '/' ? '' : '/') + 'cart/add.js';
  }

  function optionIndex(names, needle) {
    for (var i = 0; i < (names || []).length; i++) {
      if (String(names[i] || '').toLowerCase().indexOf(needle) !== -1) return i;
    }
    return -1;
  }

  function sizeIndex(names) { return optionIndex(names, 'size'); }
  function colorIndex(names) {
    var i = optionIndex(names, 'color');
    return i >= 0 ? i : optionIndex(names, 'colour');
  }

  function readVariantJson(card) {
    var script = card.querySelector('[data-piv1-fs-variant-json]') || card.querySelector('[data-raf-mqa-json]');
    if (!script) return null;
    try { return JSON.parse(script.textContent || '{}'); } catch (e) { return null; }
  }

  function imageForColor(data, colorVal) {
    var fallback = data.image || '';
    if (!colorVal) return fallback;

    var map = data.colorImages || {};
    if (map[colorVal]) return map[colorVal];

    var cIdx = colorIndex(data.options || []);
    var variants = data.variants || [];
    if (cIdx < 0) return fallback;

    var i;
    for (i = 0; i < variants.length; i++) {
      var v = variants[i];
      if ((v.options || [])[cIdx] !== colorVal) continue;
      if (v.image) return v.image;
    }
    return fallback;
  }

  function updateCardImage(card, src) {
    if (!src) return;
    var img = card.querySelector('img.piv1-fs-card__img') || card.querySelector('[data-piv1-fs-card-img]');
    if (!img) return;
    img.removeAttribute('srcset');
    img.removeAttribute('sizes');
    img.src = src;
  }

  function updateCardSwatches(card, colorVal) {
    if (!colorVal) return;
    card.querySelectorAll('[data-piv1-fs-info-swatch]').forEach(function (sw) {
      var name = sw.getAttribute('data-color-name') || sw.getAttribute('title') || '';
      sw.classList.toggle('is-active', name === colorVal);
    });
  }

  function selectCardColor(card, data, colorVal) {
    card._piv1FsColor = colorVal;
    var src = imageForColor(data, colorVal);
    updateCardImage(card, src);
    updateCardSwatches(card, colorVal);
    renderHoverPicker(card, data, colorVal);
  }

  function uniqueValues(data, idx, filterIdx, filterVal) {
    var values = [];
    var seen = {};
    (data.variants || []).forEach(function (v) {
      var opts = v.options || [];
      if (filterIdx >= 0 && filterVal && opts[filterIdx] !== filterVal) return;
      var label = opts[idx];
      if (!label || seen[label]) return;
      seen[label] = true;
      values.push(label);
    });
    return values;
  }

  function matchVariant(data, sizeVal, colorVal) {
    var names = data.options || [];
    var sIdx = sizeIndex(names);
    var cIdx = colorIndex(names);
    var found = null;
    (data.variants || []).forEach(function (v) {
      var opts = v.options || [];
      if (sIdx >= 0 && sizeVal && opts[sIdx] !== sizeVal) return;
      if (cIdx >= 0 && colorVal && opts[cIdx] !== colorVal) return;
      if (v.available) { found = v; return; }
      if (!found) found = v;
    });
    return found;
  }

  function swatchStyle(label, data) {
    var map = (data && data.swatches) || {};
    var s = map[label] || {};
    if (s.image) return 'background-image:url(' + String(s.image).replace(/"/g, '') + ')';
    if (s.hex) return 'background-color:' + s.hex;
    if (s.css && CSS_COLORS[String(s.css).toLowerCase()]) return 'background-color:' + CSS_COLORS[String(s.css).toLowerCase()];
    var guess = String(label || '').split(/\s+/).pop().toLowerCase();
    return 'background-color:' + (CSS_COLORS[guess] || guess || '#ccc');
  }

  function openCartDrawer(detail) {
    document.dispatchEvent(new CustomEvent('ajaxProduct:added', { detail: detail, bubbles: true }));
    document.dispatchEvent(new CustomEvent('cart-drawer:open', { detail: detail, bubbles: true }));
    if (window.CartDrawerRaf && typeof window.CartDrawerRaf.open === 'function') {
      window.CartDrawerRaf.open();
    }
    if (window.theme && theme.cart && typeof theme.cart.getCart === 'function') {
      theme.cart.getCart();
    }
  }

  function addToCart(variantId, btn) {
    if (!variantId) return;
    if (btn && btn.classList.contains('is-loading')) return;
    if (btn) {
      if (!btn.dataset.piv1FsLabel) btn.dataset.piv1FsLabel = btn.textContent;
      btn.classList.remove('is-added');
      btn.classList.add('is-loading');
      btn.setAttribute('aria-busy', 'true');
    }
    fetch(cartAddUrl(), {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      credentials: 'same-origin',
      body: JSON.stringify({ id: Number(variantId), quantity: 1 })
    })
      .then(function (res) {
        return res.json().then(function (body) {
          if (!res.ok) throw new Error((body && (body.description || body.message)) || 'Could not add');
          return body;
        });
      })
      .then(function (item) {
        openCartDrawer(item);
        if (btn) {
          btn.classList.add('is-added');
          btn.textContent = 'Added';
          btn.setAttribute('aria-busy', 'false');
        }
      })
      .catch(function (err) {
        if (console && console.warn) console.warn('[Find Similar] add failed', err);
        if (btn) {
          btn.textContent = btn.dataset.piv1FsLabel || btn.textContent;
          btn.setAttribute('aria-busy', 'false');
        }
      })
      .then(function () {
        if (btn) btn.classList.remove('is-loading');
      });
  }

  function bindHoverPanel(card, data) {
    var hover = card.querySelector('[data-piv1-fs-hover]');
    if (!hover || hover.dataset.piv1FsBound === '1') return;
    hover.dataset.piv1FsBound = '1';

    hover.addEventListener('click', function (e) {
      var colorBtn = e.target.closest('[data-piv1-fs-hover-color]');
      if (colorBtn) {
        e.preventDefault();
        e.stopPropagation();
        selectCardColor(card, data, colorBtn.getAttribute('data-piv1-fs-hover-color') || '');
        return;
      }

      var sizeBtn = e.target.closest('[data-piv1-fs-hover-size][data-variant-id]');
      if (sizeBtn) {
        e.preventDefault();
        e.stopPropagation();
        addToCart(sizeBtn.getAttribute('data-variant-id'), sizeBtn);
      }
    });
  }

  function renderHoverPicker(card, data, colorVal) {
    var hover = card.querySelector('[data-piv1-fs-hover]');
    var colorsEl = card.querySelector('[data-piv1-fs-hover-colors]');
    var sizesEl = card.querySelector('[data-piv1-fs-hover-sizes]');
    if (!hover || !sizesEl || !data) return;

    var names = data.options || [];
    var cIdx = colorIndex(names);
    var sIdx = sizeIndex(names);

    if (data.hasOnlyDefault) {
      colorsEl.hidden = true;
      var only = (data.variants || [])[0];
      sizesEl.innerHTML = only && only.available
        ? '<button type="button" class="piv1-fs-card__hover-size" data-variant-id="' + only.id + '">Add to bag</button>'
        : '<span class="piv1-fs-card__hover-oos">Out of stock</span>';
      hover.hidden = false;
      return;
    }

    if (cIdx >= 0) {
      colorsEl.hidden = false;
      colorsEl.innerHTML = uniqueValues(data, cIdx, -1, '').map(function (label) {
        var active = label === colorVal ? ' is-active' : '';
        return '<button type="button" class="piv1-fs-card__hover-swatch' + active + '" data-piv1-fs-hover-color="' +
          label.replace(/"/g, '&quot;') + '" style="' + swatchStyle(label, data) +
          '" title="' + label.replace(/"/g, '&quot;') + '" aria-label="' + label.replace(/"/g, '&quot;') + '"></button>';
      }).join('');
    } else {
      colorsEl.hidden = true;
      colorsEl.innerHTML = '';
    }

    if (sIdx >= 0) {
      sizesEl.innerHTML = uniqueValues(data, sIdx, cIdx, colorVal).map(function (label) {
        var v = matchVariant(data, label, colorVal);
        if (v && v.available) {
          return '<button type="button" class="piv1-fs-card__hover-size" data-piv1-fs-hover-size data-variant-id="' + v.id + '">' + label + '</button>';
        }
        return '<span class="piv1-fs-card__hover-size is-oos">' + label + '</span>';
      }).join('');
    } else if (cIdx >= 0) {
      sizesEl.innerHTML = uniqueValues(data, cIdx, -1, '').map(function (label) {
        var v = matchVariant(data, '', label);
        if (v && v.available) {
          return '<button type="button" class="piv1-fs-card__hover-size" data-piv1-fs-hover-size data-variant-id="' + v.id + '">' + label + '</button>';
        }
        return '<span class="piv1-fs-card__hover-size is-oos">' + label + '</span>';
      }).join('');
    } else {
      sizesEl.innerHTML = (data.variants || []).map(function (v) {
        if (v.available) {
          return '<button type="button" class="piv1-fs-card__hover-size" data-piv1-fs-hover-size data-variant-id="' + v.id + '">Add to bag</button>';
        }
        return '';
      }).join('');
    }

    hover.hidden = false;
  }

  function getCards(fs) {
    var modal = getModal(fs);
    var root = modal || fs;
    return root.querySelectorAll('[data-piv1-fs-card]');
  }

  function initCardHovers(fs) {
    getCards(fs).forEach(initCardHover);
  }

  function initCardHover(card) {
    if (card.dataset.piv1FsHoverReady === '1') return;
    card.dataset.piv1FsHoverReady = '1';

    var data = readVariantJson(card);
    if (!data) return;

    var media = card.querySelector('.piv1-fs-card__media');
    if (!media) return;

    var colorVal = data.color || '';
    var cIdx = colorIndex(data.options || []);
    if (!colorVal && cIdx >= 0) {
      var colors = uniqueValues(data, cIdx, -1, '');
      colorVal = colors[0] || '';
    }
    card._piv1FsColor = colorVal;
    bindHoverPanel(card, data);

    function showHover() {
      if (window.matchMedia('(max-width: 768px)').matches) return;
      renderHoverPicker(card, data, card._piv1FsColor);
    }

    function hideHover(e) {
      if (e && e.relatedTarget && card.contains(e.relatedTarget)) return;
      var hover = card.querySelector('[data-piv1-fs-hover]');
      if (hover) hover.hidden = true;
    }

    card.addEventListener('mouseenter', showHover);
    card.addEventListener('mouseleave', hideHover);
  }

  function visibleCount(grid) {
    if (!grid) return 0;
    var n = 0;
    grid.querySelectorAll('[data-piv1-fs-card]').forEach(function (card) {
      if (!card.hidden) n += 1;
    });
    return n;
  }

  function getActiveSizes(modal) {
    var sizes = [];
    modal.querySelectorAll('[data-piv1-fs-size].is-active').forEach(function (btn) {
      sizes.push(btn.getAttribute('data-piv1-fs-size') || '');
    });
    return sizes.filter(Boolean);
  }

  function updateFilterUi(modal) {
    var activeSizes = getActiveSizes(modal);
    var n = activeSizes.length;
    var clearBtn = modal.querySelector('[data-piv1-fs-clear]');
    var clearCount = modal.querySelector('[data-piv1-fs-clear-count]');
    var sizeHeading = modal.querySelector('[data-piv1-fs-size-heading]');
    var filterWrap = modal.querySelector('[data-piv1-fs-sizes]');
    var baseLabel = (filterWrap && filterWrap.getAttribute('data-piv1-fs-size-label')) || 'Size';

    if (clearBtn) clearBtn.hidden = n === 0;
    if (clearCount) clearCount.textContent = String(n);
    if (sizeHeading) sizeHeading.textContent = n > 0 ? baseLabel + ' (' + n + ')' : baseLabel;
  }

  function applyFilter(modal) {
    var grid = modal.querySelector('[data-piv1-fs-grid]');
    var countEl = modal.querySelector('[data-piv1-fs-count]');
    var activeSizes = getActiveSizes(modal);
    if (!grid) return;
    grid.querySelectorAll('[data-piv1-fs-card]').forEach(function (card) {
      var sizes = (card.getAttribute('data-sizes') || '').split('|').filter(Boolean);
      if (activeSizes.length === 0) {
        card.hidden = false;
        return;
      }
      var match = false;
      for (var i = 0; i < activeSizes.length; i++) {
        if (sizes.indexOf(activeSizes[i]) !== -1) {
          match = true;
          break;
        }
      }
      card.hidden = !match;
    });
    updateFilterUi(modal);
    if (countEl) {
      var label = (countEl.textContent || '').replace(/^\d+\s*/, '');
      countEl.textContent = visibleCount(grid) + ' ' + label;
    }
  }

  function clearSizeFilters(modal) {
    modal.querySelectorAll('[data-piv1-fs-size].is-active').forEach(function (btn) {
      btn.classList.remove('is-active');
    });
    applyFilter(modal);
  }

  function applySort(modal, mode) {
    var grid = modal.querySelector('[data-piv1-fs-grid]');
    if (!grid) return;
    var cards = Array.prototype.slice.call(grid.querySelectorAll('[data-piv1-fs-card]'));
    cards.sort(function (a, b) {
      if (mode === 'price-asc') return (parseInt(a.getAttribute('data-price'), 10) || 0) - (parseInt(b.getAttribute('data-price'), 10) || 0);
      if (mode === 'price-desc') return (parseInt(b.getAttribute('data-price'), 10) || 0) - (parseInt(a.getAttribute('data-price'), 10) || 0);
      if (mode === 'title') return String(a.getAttribute('data-title') || '').localeCompare(String(b.getAttribute('data-title') || ''));
      return (parseInt(a.getAttribute('data-index'), 10) || 0) - (parseInt(b.getAttribute('data-index'), 10) || 0);
    });
    cards.forEach(function (card) { grid.appendChild(card); });
  }

  function closeModal(fs) {
    var modal = getModal(fs);
    if (!modal) return;
    modal.hidden = true;
    document.documentElement.classList.remove('piv1-fs-open');
    var opener = fs.querySelector('[data-piv1-fs-open]');
    if (opener) { try { opener.focus(); } catch (e) {} }
  }

  function openModal(fs) {
    var modal = getModal(fs);
    if (!modal) return;
    portalModal(fs, modal);
    initCardHovers(fs);
    modal.hidden = false;
    document.documentElement.classList.add('piv1-fs-open');
    var closeBtn = modal.querySelector('.piv1-fs-modal__close');
    if (closeBtn) { try { closeBtn.focus(); } catch (e) {} }
  }

  function initFindSimilar(root) {
    root.querySelectorAll('[data-piv1-fs]').forEach(function (fs) {
      if (fs.dataset.piv1FsReady === '1') return;
      fs.dataset.piv1FsReady = '1';

      var modal = getModal(fs);
      initCardHovers(fs);

      var openBtn = fs.querySelector('[data-piv1-fs-open]');
      if (openBtn && modal) {
        openBtn.addEventListener('click', function () { openModal(fs); });
      }

      if (modal) {
        modal.querySelectorAll('[data-piv1-fs-close]').forEach(function (el) {
          el.addEventListener('click', function () { closeModal(fs); });
        });

        modal.querySelectorAll('[data-piv1-fs-size]').forEach(function (btn) {
          btn.addEventListener('click', function () {
            btn.classList.toggle('is-active');
            applyFilter(modal);
          });
        });

        var clearBtn = modal.querySelector('[data-piv1-fs-clear]');
        if (clearBtn) {
          clearBtn.addEventListener('click', function () {
            clearSizeFilters(modal);
          });
        }

        var sizeToggle = modal.querySelector('[data-piv1-fs-size-toggle]');
        var sizeWrap = modal.querySelector('[data-piv1-fs-sizes]');
        if (sizeToggle && sizeWrap) {
          sizeToggle.addEventListener('click', function () {
            var collapsed = sizeWrap.classList.toggle('is-collapsed');
            sizeToggle.setAttribute('aria-expanded', collapsed ? 'false' : 'true');
          });
        }

        var sort = modal.querySelector('[data-piv1-fs-sort]');
        if (sort) {
          sort.addEventListener('change', function () { applySort(modal, sort.value); });
        }
      }
    });
  }

  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Escape') return;
    document.querySelectorAll('[data-piv1-fs-modal]:not([hidden])').forEach(function (modal) {
      var fs = modal.dataset.piv1FsOwner ? document.getElementById(modal.dataset.piv1FsOwner) : null;
      if (fs) closeModal(fs);
    });
  });

  window.Piv1FindSimilar = { init: initFindSimilar };

  function boot() {
    document.querySelectorAll('[data-piv1]').forEach(initFindSimilar);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', function (e) {
    var root = e.target.querySelector('[data-piv1]') || e.target;
    initFindSimilar(root);
  });
})();
